import React, { useState, useEffect , useRef } from "react";
import L from 'leaflet';
import axios from 'axios';
import { API_URL } from "../constants";
import { useHistory } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const ClientLocalisation = ({ motor, token, setMotor }) => {
  const [showAddClient, setShowAddClient] = useState(false);
  const [client, setClient] = useState("");
  const [localisation, setLocalisation] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [filteredClientList, setFilteredClientList] = useState([]);
  const [selectedFromMap, setSelectedFromMap] = useState(false);
  const [clientLocList, setClientLocList] = useState([]);
  const navigate = useHistory();
  const [showEditClientModal, setShowEditClientModal] = useState(false);
  const [showEditLocModal, setShowEditLocModal] = useState(false);
  const [showMap, setShowMap] = useState(false);
  const [resolvedClient, setResolvedClient] = useState("");
  const [resolvedLocalisation, setResolvedLocalisation] = useState("");
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  console.log("motor", motor);

  const showMessagePopup = (message) => {
    alert(message);
  };

  useEffect(() => {
    fetchClientLoc();
  }, []);

  useEffect(() => {
    if (showEditLocModal) {
      setLocalisation(resolvedLocalisation || "");
      setShowMap(true); 
    } else {
      setSuggestions([]);
      setShowMap(false);
    }
  }, [showEditLocModal, resolvedLocalisation]);


  useEffect(() => {
    if (showEditClientModal) {
      setClient(resolvedClient || "");
    }
  }, [showEditClientModal, resolvedClient]);
  

  useEffect(() => {
    if (showMap) {
      const map = L.map('map').setView([46.603354, 1.888334], 6);
      mapRef.current = map;

      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: 'Map data &copy; OpenStreetMap contributors',
      }).addTo(map);

      map.on('click', async (e) => {
        const { lat, lng } = e.latlng;

        try {
          const response = await axios.get(`https://api-adresse.data.gouv.fr/reverse/?lat=${lat}&lon=${lng}`);
          const data = response.data;

          const address = {
            streetNumber: data.features[0].properties.housenumber || '',
            streetName: data.features[0].properties.street || '',
            postalCode: data.features[0].properties.postcode || '',
            city: data.features[0].properties.city || data.features[0].properties.town || data.features[0].properties.village || '',
          };

          const formattedAddress = `${address.streetNumber} ${address.streetName}, ${address.postalCode} ${address.city}`;

          setLocalisation(formattedAddress);
          setSelectedFromMap(true);

          if (markerRef.current) {
            map.removeLayer(markerRef.current);
          }

          markerRef.current = L.marker([lat, lng])
            .addTo(map)
            .bindPopup(formattedAddress)
            .openPopup();
        } catch (error) {
          console.error(error);
        }
      });

      return () => {
        map.remove();
      };
    }
  }, [showMap]);
  
  const geocodeAddressAndSetMarker = async (addressText) => {
    try {
      const encodedText = encodeURIComponent(addressText).replace(/%20/g, '+');
      const response = await axios.get(`https://api-adresse.data.gouv.fr/search/?q=${encodedText}`);
      const data = response.data;

      if (data.features.length > 0) {
        const feature = data.features[0];
        const [lng, lat] = feature.geometry.coordinates;
        const label = feature.properties.label;

        setLocalisation(label);

        if (mapRef.current) {
          mapRef.current.setView([lat, lng], 14);

          if (markerRef.current) {
            mapRef.current.removeLayer(markerRef.current);
          }

          markerRef.current = L.marker([lat, lng])
            .addTo(mapRef.current)
            .bindPopup(label)
            .openPopup();
        }
      }
    } catch (error) {
      console.error("Erreur lors du géocodage :", error);
    }
  };

  const handleClientChange = (event) => {
    const searchText = event.target.value;
    setClient(searchText);
    
    const filteredList = clientLocList.filter((item) =>
      item.client.toLowerCase().includes(searchText.toLowerCase())
    );
    setFilteredClientList(filteredList);
  };

  const showFirstSuggestionOnMap = async (searchText) => {
  try {
    const encodedText = encodeURIComponent(searchText).replace(/%20/g, '+');
    const response = await axios.get(`https://api-adresse.data.gouv.fr/search/?q=${encodedText}`);
    const data = response.data;

    if (data.features.length > 0) {
      const feature = data.features[0];
      const [lng, lat] = feature.geometry.coordinates;
      const label = feature.properties.label;

      if (mapRef.current) {
        mapRef.current.setView([lat, lng], 14);

        if (markerRef.current) {
          mapRef.current.removeLayer(markerRef.current);
        }

        markerRef.current = L.marker([lat, lng])
          .addTo(mapRef.current)
          .bindPopup(label)
          .openPopup();
      }
    }
  } catch (error) {
    console.error("Erreur lors du géocodage de la première suggestion :", error);
  }
};

  useEffect(() => {
    if (motor.clientLoc && clientLocList.length > 0) {
      const matched = clientLocList.find(item => item._id === motor.clientLoc);
      if (matched) {
        setResolvedClient(matched.client);
        setResolvedLocalisation(matched.localisation);
      }
    }
  }, [motor.clientLoc, clientLocList]);
  
  const handleLocalisationChange = async (e) => {
  const searchText = e.target.value;
  setLocalisation(searchText);

  if (!selectedFromMap && searchText.length >= 4) {
    try {
      const encodedText = encodeURIComponent(searchText).replace(/%20/g, '+');
      const response = await axios.get(
        `https://api-adresse.data.gouv.fr/search/?q=${encodedText}`
      );
      const data = response.data;

      setSuggestions(data.features.map(feature => feature.properties));

      // Afficher la première suggestion sur la carte, sans modifier l'input localisation
      if (data.features.length > 0) {
        showFirstSuggestionOnMap(searchText);
      }

    } catch (error) {
      console.error(error);
    }
  } else {
    setSelectedFromMap(false);
    setSuggestions([]);
  }
};

  const handleSuggestionAdresse
   = (address) => {
    setLocalisation(address.label);
    setSuggestions([]);
    geocodeAddressAndSetMarker(address.label);
  };

  const handleClientLocSelect = (selectedClient, selectedLocalisation) => {
    setClient(selectedClient);
    setLocalisation(selectedLocalisation);
    setFilteredClientList([]);
  };

  const handleClientLocSubmit = async () => {
    try {
      const response = await axios.put(`${API_URL}/moteur/setclientloc`, {
        client: client,
        localisation: localisation,
        id_moteur: motor._id,
      }, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      if (response.status === 401) {
        showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear(); 
        navigate.push("/login");
        return;
      }
      const json = response.data;
      console.log(json);
      setMotor(json);
      await fetchClientLoc();
      window.location.reload()
      localStorage.setItem("motor", JSON.stringify(json));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchClientLoc = async () => {
    try {
      const response = await axios.get(`${API_URL}/moteur/listclientloc`, {
        headers: {
          Accept: 'application/json',
          Authorization: 'Bearer ' + token,
        },
      });
      if (response.status === 401) {
        showMessagePopup("ERREUR : Votre session a expiré. Veuillez vous reconnecter pour continuer.");
        localStorage.clear(); 
        navigate.push("/login");
        return;
      }
      const data = response.data;
      setClientLocList(data.data);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      {!resolvedClient && !resolvedLocalisation ? (
        !showAddClient ? (
          <button
            onClick={(event) => {setShowAddClient(true); setShowMap(true); event.stopPropagation()}}
            className="bg-bleuSTB text-white text-xl 3xl:text-3xl mb-4  rounded-2xl px-4 py-4 mt-4 cursor-pointer hover:bg-marronSTB"
          >
            Ajouter un client et une localisation
          </button>
        ) : (
          <div>
            <input
              type="text"
              placeholder="Client"
              value={client}
              onChange={handleClientChange}
              className="text-base 3xl:text-xl border-2 border-orangeButton hover:border-bleuSTB w-50 sm:w-50 rounded-xl p-2 mr-2 mt-5"
              onClick={event => event.stopPropagation()}
            />
            <input
              type="text"
              placeholder="Localisation"
              value={localisation}
              onChange={handleLocalisationChange}
              className="text-base 3xl:text-xl border-2 border-orangeButton hover:border-bleuSTB w-96 sm:w-50  rounded-xl p-2 mr-5 mt-5"
              onKeyDown={(e) => {
              if (e.key === 'Enter') {
                e.preventDefault();
                geocodeAddressAndSetMarker(localisation);
              }
            }}
              onClick={event => event.stopPropagation()}
            />
            {localisation ? (
              <ul className="list-none p-0 m-0 mt-4 text-xl 3xl:text-3xl font-semibold max-h-48 overflow-y-auto pr-2">
                {suggestions.map((address, index) => (
                  <li
                    key={index}
                    onClick={() => handleSuggestionAdresse(address)}
                    className="p-2 cursor-pointer bg-gray-200 rounded-md mb-2 text-gray-700 transition-colors duration-300 hover:bg-gray-300"
                  >
                    <span className="mr-5 text-2xl">{'→'}</span>{address.label}
                  </li>
                ))}
              </ul>
            ) : null}

            {client ? (
              <ul className="list-none p-0 m-0 mt-4 text-xl 3xl:text-3xl font-semibold max-h-64 overflow-y-auto pr-2">
                {filteredClientList.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => handleClientLocSelect(item.client, item.localisation)}
                    className="p-2 cursor-pointer bg-gray-200 rounded-md mb-2 text-gray-700 transition-colors duration-300 hover:bg-gray-300"
                  >
                    <span className="mr-5 text-2xl">{'→'}</span>{item.client} - {item.localisation}
                  </li>
                ))}
              </ul>
            ) : null}
            <div
              id="map"
              style={{ marginTop: "2em", marginBottom: "2em", height: "400px", width: "100%" }}
              onClick={event => event.stopPropagation()}
            ></div>
            <div className="flex gap-4 mb-4">
              <button
                onClick={(event) => {
                  handleClientLocSubmit();
                  event.stopPropagation();
                }}
                className="bg-bleuSTB text-white text-xl 3xl:text-3xl rounded-2xl px-10 py-4 cursor-pointer hover:bg-marronSTB"
              >
                Valider
              </button>
              <button
                onClick={(event) => {
                  setClient("");
                  setLocalisation("");
                  setSuggestions([]);
                  setShowAddClient(false);
                  setShowMap(false);
                  event.stopPropagation();
                }}
                className="bg-gray-300 text-gray-800 text-xl 3xl:text-3xl rounded-2xl px-10 py-4 cursor-pointer hover:bg-gray-400"
              >
                Annuler
              </button>
            </div>
          </div>
        )
      ) : (
        <h4 className="pt-4 text-xl 3xl:text-3xl mb-4 underline font-bold">
          {!resolvedClient ? (
            <div className="">Client</div>
          ) : (
            <div>
              <div className="">Client</div>
              <br />
              <div className="flex items-center gap-2">
                <span className="inline-block text-decoration-none font-light">{resolvedClient}</span>
                <FaEdit className="cursor-pointer text-bleuSTB hover:text-marronSTB ml-2" onClick={() => setShowEditClientModal(true)} />
              </div>
            </div>
          )}
          <br />
          {!resolvedLocalisation ? (
            <div>Localisation</div>
          ) : (
            <div>
              <div>Localisation</div>
              <br />
              <div className="flex items-center gap-2">
                <span className="inline-block text-decoration-none font-light text-xl 3xl:text-3xl">{resolvedLocalisation}</span>
                <FaEdit className="cursor-pointer text-bleuSTB hover:text-marronSTB ml-2" onClick={() => setShowEditLocModal(true)} />
              </div>
            </div>
          )}
        </h4>
      )}
      {showEditClientModal && (
          <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex justify-center items-center px-4">
            <div
              className="bg-white rounded-2xl shadow-xl w-full max-w-4xl p-6"
              onClick={e => e.stopPropagation()}
            >
              <h2 className="text-2xl text-center 3xl:text-3xl font-bold text-gray-800 mb-4">
                Modifier le client
              </h2>

              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-6">
                <input
                  type="text"
                  value={client}
                  onChange={e => setClient(e.target.value)}
                  placeholder="Nouveau nom du client"
                  className="text-base 3xl:text-xl border-2 border-orangeButton hover:border-bleuSTB rounded-xl px-4 py-2 w-full md:w-96"
                />
              </div>

              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowEditClientModal(false)}
                  className="text-gray-600 text-lg hover:text-gray-900 transition"
                >
                  Annuler
                </button>
                <button
                  onClick={async () => {
                    await axios.put(`${API_URL}/moteur/updateclientloc`, {
                      id: motor.clientLoc,
                      client
                    }, {
                      headers: { Authorization: "Bearer " + token }
                    });
                    setMotor({ ...motor, client });
                    localStorage.setItem("motor", JSON.stringify({ ...motor, client }));
                    setShowEditClientModal(false);
                    await fetchClientLoc();
                  }}
                  className="bg-bleuSTB text-white text-lg 3xl:text-2xl rounded-2xl px-6 py-3 hover:bg-marronSTB transition"
                >
                  Sauvegarder
                </button>
              </div>
            </div>
          </div>
        )}
      {showEditLocModal && (
          <div className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex justify-center items-center px-4">
            <div
              className="bg-white rounded-2xl shadow-xl w-full max-w-4xl p-6"
              onClick={e => e.stopPropagation()}
            >
              <h2 className="text-2xl 3xl:text-3xl font-bold text-gray-800 mb-4 text-center">
                Modifier la localisation
              </h2>

              <div className="flex flex-col md:flex-row items-start md:items-center gap-4 mb-4">
                <input
                  type="text"
                  value={localisation}
                  onChange={handleLocalisationChange}
                  placeholder="Nouvelle localisation"
                  className="text-base 3xl:text-xl border-2 border-orangeButton hover:border-bleuSTB rounded-xl px-4 py-2 w-full md:w-96"
                />
              </div>

              {suggestions.length > 0 && (
                <ul className="list-none mt-2 mb-4 text-xl 3xl:text-3xl font-semibold max-h-60 overflow-y-auto">
                  {suggestions.map((address, index) => (
                    <li
                      key={index}
                      onClick={() => {
                        handleSuggestionAdresse(address);
                        setSuggestions([]);
                      }}
                      className="p-2 cursor-pointer bg-gray-200 rounded-md mb-3 text-gray-700 transition duration-300 hover:bg-gray-300"
                    >
                      <span className="mr-3 text-2xl">{'→'}</span>{address.label}
                    </li>
                  ))}
                </ul>
              )}
                {showMap && (
                  <div
                    id="map"
                    style={{ marginTop: "2em", marginBottom: "2em", height: "400px", width: "100%" }}
                    onClick={(event) => event.stopPropagation()}
                  />
                )}
              <div className="flex justify-end gap-4">
                <button
                  onClick={() => setShowEditLocModal(false)}
                  className="text-gray-600 text-lg hover:text-gray-900 transition"
                >
                  Annuler
                </button>
                <button
                  onClick={async () => {
                    await axios.put(`${API_URL}/moteur/updateclientloc`, {
                      id: motor.clientLoc,
                      localisation
                    }, {
                      headers: { Authorization: "Bearer " + token }
                    });
                    setMotor({ ...motor, localisation });
                    localStorage.setItem("motor", JSON.stringify({ ...motor, localisation }));
                    setShowEditLocModal(false);
                    await fetchClientLoc();
                  }}
                  className="bg-bleuSTB text-white text-lg 3xl:text-2xl rounded-2xl px-6 py-3 hover:bg-marronSTB transition"
                >
                  Sauvegarder
                </button>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

export default ClientLocalisation;